module.exports = __webpack_public_path__ + "static/img/e8b9a81.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/bdyxgg/logo.png
// module id = 628
// module chunks = 2